<div class="main">
    <div class="heading">Welcome To Manyata!</div>

    <!-- <div class="content">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Soluta ea ex sed perspiciatis a delectus quibusdam
        quaerat iusto.
    </div> -->

    <div class="footer">Already a user? <span (click)="loginClick()" class="login">Login</span></div>
</div>